<div class="app-shell">
  <aside class="sidebar">
    <div class="sidebar-main">
      <div class="brand-block">
        <img src="invento-logo.png" alt="Invento" class="brand-logo" />
      </div>

      <nav class="nav-list" aria-label="Primary">
        <a routerLink="/overview" routerLinkActive="active">Overview</a>

        <p class="nav-section-label">Intelligence</p>
        <a routerLink="/developers" routerLinkActive="active">Developers</a>
        <a routerLink="/repositories" routerLinkActive="active">Repositories</a>
        <a routerLink="/signals" routerLinkActive="active">Risk Signals</a>

        <p class="nav-section-label">Analytics</p>
        <a routerLink="/trends" routerLinkActive="active">Trends</a>
        <a routerLink="/hotspots" routerLinkActive="active">Hotspots</a>
        <a routerLink="/recurring-issues" routerLinkActive="active">Recurring Issues</a>

        <p class="nav-section-label">Explore</p>
        <a routerLink="/issues" routerLinkActive="active">Issue Explorer</a>
        <a routerLink="/operations" routerLinkActive="active">Operations</a>

        <p class="nav-section-label">Management</p>
        <a routerLink="/rules" routerLinkActive="active">Rules & BRDs</a>
      </nav>
    </div>
  </aside>

  <main class="content-shell">
    <header class="topbar">
      <div class="topbar-copy">
        <p class="topbar-label">Control Panel</p>
        <h2>Review Ops</h2>
      </div>

      <div class="topbar-range">
        <label class="date-field">
          <span>From</span>
          <input type="date" [ngModel]="dateRange.draftFrom()" (ngModelChange)="dateRange.updateDraftFrom($event)" />
        </label>

        <label class="date-field">
          <span>To</span>
          <input type="date" [ngModel]="dateRange.draftTo()" (ngModelChange)="dateRange.updateDraftTo($event)" />
        </label>

        <div class="topbar-actions">
          <button type="button" class="ghost-button" (click)="dateRange.resetLast30Days()">Last 30 days</button>
          <button type="button" class="primary-button" (click)="dateRange.apply()">Apply</button>
          <p-button
            [icon]="isDark() ? 'pi pi-sun' : 'pi pi-moon'"
            [pTooltip]="isDark() ? 'Light mode' : 'Dark mode'"
            severity="secondary"
            [text]="true"
            size="small"
            (onClick)="toggleTheme()"
            styleClass="theme-toggle-btn">
          </p-button>
          @if (auth.me(); as me) {
            <div class="flex items-center gap-2 rounded-full border px-3 py-1 text-xs" [pTooltip]="me.email">
              <span class="font-medium">{{ me.displayName }}</span>
              @if (me.isAdmin) {
                <span class="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700">admin</span>
              }
              <p-button
                icon="pi pi-sign-out"
                severity="secondary"
                [text]="true"
                size="small"
                pTooltip="Sign out"
                (onClick)="auth.signOut()">
              </p-button>
            </div>
          }
        </div>
      </div>
    </header>

    <div class="page-shell">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
